import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import * as d3 from "d3";
import { Subscription } from "rxjs";
import { GraphStateService } from "../../../core-module/services/state/graph-state.service";
import { CloGraphBase } from "../clo-graph-base";

@Component({
  standalone: false,
  selector: 'app-clo-graph',
  templateUrl: './clo-graph.component.html',
  styleUrls: ['./clo-graph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CloGraphComponent extends CloGraphBase implements OnInit, OnDestroy {
  clonedData: LegacyAny[] = [];
  graphSub: Subscription;
  enableGraphSub: Subscription;

  protected get graphState(): GraphStateService {
    return this._graphState;
  }

  constructor(
    private readonly _graphState: GraphStateService,
    private readonly ref: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.enableGraphSub = this._graphState.checkEnableGraph.subscribe((data) => {
      this.graphDisabled = data;
      this.ref.markForCheck();
    });

    this.graphSub = this._graphState.getCloGraphData.subscribe((data) => {
      if (data != "") {
        if (data.graphPoints.length) {
          this.data = data.graphPoints;
          this.graphType = data.graphType;
          this.expandNonInterpolationData();
          this.clonedData = Object.assign([], this.data);
          const newdataLeangth = this.clonedData.length;
          if (this.clonedData[newdataLeangth - 1].hour < 120) {
            this.clonedData[newdataLeangth] = {
              hour: 120,
              power: this.clonedData[newdataLeangth - 1].power,
            };
          }
          this.buildSvg();
          this.addXandYAxis();
          this.drawLineAndPath();
          this.addDrag();
        }

        if (!data["graphPoints"].length) {
          d3.selectAll("#svg2 > *").remove();
        }
      }
    });
  }

  public drawLineAndPath() {
    this.applyRenderedGraph(this.clonedData, 0 - this.height / 2 - 50);
  }

  public dragended(d) {
    if (!this.successfullDrag) {
      return;
    }

    const newArrayData = this.collapseAndValidate(false);
    this._graphState.updateGraphData(newArrayData);
  }

  checkValidInputRange(inputData) {
    this.collapseAndValidate(false);
  }

  ngOnDestroy() {
    this._graphState.updateGraphData([]);
    this.data = [];
    this.clonedData = [];
    this.graphSub.unsubscribe();
    if (this.enableGraphSub) {
      this.enableGraphSub.unsubscribe();
    }
  }

}

